import axios from "axios";
export default (useCookie: boolean) =>
  axios.create({
    withCredentials: useCookie
  });
